import { render, staticRenderFns } from "./TransactionsSection.vue?vue&type=template&id=7d1401ef&scoped=true&"
import script from "./TransactionsSection.vue?vue&type=script&lang=js&"
export * from "./TransactionsSection.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsSection.vue?vue&type=style&index=0&id=7d1401ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1401ef",
  null
  
)

export default component.exports